import { MessageSquare, RefreshCw } from "lucide-react";
import { Link } from "react-router";

import RoleplayAssetMobile from "@/../../hypetrain/static/img/exec-home/asset-ai-mobile.png";
import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";
import { BaseLottieAnimation } from "@/components/pieces/animations/BaseLottieAnimation";
import { Button } from "@/components/ui/button";

export function RoleplaysCallout() {
  return (
    <div className="relative w-full overflow-hidden rounded-3xl bg-blue-200">
      {/* Background image - hidden on mobile, visible on md+ */}
      <div
        className="absolute right-0 z-0 hidden h-full w-full max-w-3xs md:block lg:max-w-sm xl:max-w-md"
        style={{ overflow: "hidden" }}
      >
        <div
          className="h-full w-full"
          style={{ display: "flex", alignItems: "stretch", height: "100%" }}
        >
          <BaseLottieAnimation animationUrl="https://placement-pub.s3.us-east-2.amazonaws.com/airoleplays.json" />
        </div>
      </div>

      {/* Mobile-only image container that shows at the top on small screens */}
      <div className="block max-h-64 w-full overflow-hidden md:hidden">
        <EmbedSvg
          src={RoleplayAssetMobile}
          alt="AI Roleplays"
          className="w-full"
        />
      </div>

      {/* Content container - full width on mobile, 2/3 width on md+ */}
      <div className="flex w-full flex-col gap-6 px-6 py-9 md:w-2/3 md:gap-12 md:p-12 lg:p-16">
        <div className="max-w-2xl">
          <div className="mb-4 text-lg font-semibold text-blue-700 md:text-2xl">
            AI Roleplays
          </div>

          <div className="text-2xl/snug font-semibold text-gray-800 md:text-3xl/snug">
            Certify your team to have high-stakes conversations in a
            low-pressure setting
          </div>
        </div>

        <div className="flex flex-col gap-6 md:flex-row">
          <div className="flex flex-1 items-center gap-6 md:flex-col md:items-start">
            <div className="rounded-lg bg-blue-300 p-2">
              <MessageSquare
                className="text-blue-700"
                size={36}
                strokeWidth={1}
              />
            </div>
            <div className="text-gray-800">
              Custom scenarios help your team hone their skills and messaging.
            </div>
          </div>

          <div className="flex flex-1 items-center gap-6 md:flex-col md:items-start">
            <div className="rounded-lg bg-blue-300 p-2">
              <RefreshCw className="text-blue-700" size={36} strokeWidth={1} />
            </div>
            <div className="text-gray-800">
              Accelerate improvement with immediate feedback based on your
              evaluation criteria.
            </div>
          </div>
        </div>

        <div className="mt-6 md:mt-0">
          <Button
            intent="secondary"
            variant="outline"
            className="bg-transparent px-8 font-semibold"
            asChild
          >
            <Link to="/ai-roleplays">Learn More</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
